export default __webpack_public_path__ + "static/media/Group 161.596e07fa.png";